import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const wrapperMediaRequest = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const wrapperMediaRequestCaption = css`
  margin-top: 10px;

  a {
    font-size: 12px;
    font-weight: 700;
    line-height: 1.42;
    letter-spacing: normal;
    color: ${colors.primary.default};
    margin-left: 4px;
  }
`;
